import PrintExpired from './PrintExpired'

export default PrintExpired
